// @ts-nocheck
/**
 * Single source of truth for Rezdy booking widgets.
 *
 * The Rezdy API only exposes a product's CODE (e.g. "P0V9R2"). The numeric ID
 * used by Rezdy's hosted booking widgets (e.g. 570292) is NOT returned by the
 * API and cannot be derived from the code — you must read it once from the
 * product's booking URL in the Rezdy dashboard:
 *
 *     https://tassietours.rezdy.com/<NUMERIC_ID>/<slug>
 *                                   ^^^^^^^^^^^^
 *
 * Per-tour JSON in src/lib/data/tours/ is regenerated from the Rezdy API on
 * every build (see buildTourData.js), so the ID cannot live there — it would be
 * overwritten. Keep it here instead. To add a future tour, add one line below.
 */
export const rezdyProductIds = {
	P18ZC5: 188932,
	PJHLE0: 262968,
	PNVP8M: 211336,
	PQ5CJC: 651177,
	PQKW4C: 534771,
	PP0SGV: 288270,
	PMPLBM: 623968,
	PTC0KJ: 661924,
	PNNK81: 94219,
	PCBKLS: 521312,
	PHJFAH: 710452,
	PTNCNK: 660420,
	PHKZNS: 322300,
	P6GE12: 209693,
	P1AHF0: 373491,
	P0V9R2: 570292,
	PVHGUQ: 579518,
	PTWH1T: 581788,
	PU9VRB: 660447,
	PM5WCG: 662219,
	PBRPKL: 711040,
	PKQPM9: 710980,
	P0QKC2: 698854,
	PM0VRV: 571853,
	P0J8QR: 264285,
	PB2LG2: 276409,
	PSP9WG: 536757,
	P9TVKQ: 278655,
	PKLVUQ: 191634,
	PHBQ6G: 263144,
	PQ4FDL: 668711,
	P80WBP: 606850,
	PUYDUT: 606857,
	PMFU3K: 600152,
	PVSUAB: 600155,
	P0QZS7: 600158,
	PXA0PL: 600994,
	PKFPUC: 600998,
	P9AM50: 600999,
	PLQWG9: 567554,

	// New tours — paste the numeric ID from each product's Rezdy booking URL.
	// Until set, the booking widget renders nothing for these (intentional).
	P4N2EW: null, // TODO: 7 Day Tasmania Signature Experience (hidden for now)
	P1VDC1: 763144, // Focus on the Wild: 10-Day Tasmania Photography Tour
	P8JLJC: 769656, // Legends of Tasmania: Golf, History & Flavour – 4 Days, 4 Nights
	P01GQC: 777395 // Bruny Island Active Adventure
};

const REZDY_BASE = 'https://tassietours.rezdy.com';

/**
 * Iframe src for the inline calendar booking widget.
 * @returns {string|null} null when the tour has no Rezdy ID yet.
 */
export function getRezdyCalendarLink(productCode) {
	const id = rezdyProductIds[productCode];
	return id ? `${REZDY_BASE}/calendarWidget/${id}?iframe=true` : null;
}

/**
 * Public Rezdy booking page link (used by the "Book now" button on multi-day
 * itineraries). The slug after the ID is cosmetic — Rezdy resolves by ID.
 * @returns {string|null} null when the tour has no Rezdy ID yet.
 */
export function getRezdyBookingLink(productCode, slug = '') {
	const id = rezdyProductIds[productCode];
	return id ? `${REZDY_BASE}/${id}/${slug}` : null;
}
